export const columnHeaders = [
  'period',
  'legalentity',
  'legalentitydescription',
  'enabledflag',
  'ustaxtype',
  'localtaxtype',
  'branch',
  'source',
  'goldid',
  'countrycode',
  'minority%',
  'parent1',
  'ownership1',
  'parent2',
  'ownership2',
  'parent3',
  'ownership3',
  'parent4',
  'ownership4',
  'parent5',
  'ownership5',
  'parent6',
  'ownership6',
  'parent7',
  'ownership7',
  'parent8',
  'ownership8',
  'parent9',
  'ownership9',
  'parent10',
  'ownership10',
];
